// extracted by mini-css-extract-plugin
export default {"select":"Select_select__ZbOSZ","field":"Select_field__sh4jl","placeholder":"Select_placeholder__ITBR5","icon":"Select_icon__ly9uP","isOpen":"Select_isOpen__x4rkG"};